export default __webpack_public_path__ + "static/media/page8Image4.f969cdf0.jpeg";